import styled from 'styled-components';

import Row from 'xpi-black-ui/Base/Grid/Row/styles';
import Col from 'xpi-black-ui/Base/Grid/Col/styles';
import KeyValue from 'xpi-black-ui/Common/KeyValue/styles';

export const Container = styled.div`
  ${Row} {
    ${Col} {
      width: 50%;

      &:first-child {
        padding-right: 24px;
      }

      ${KeyValue} {
        margin-bottom: 24px;
      }
    }
  }

  .hide-text {
    width: 95%;
    height: 45px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const Wrapper = styled.div`
  margin-top: 24px;
`;
